export const colors = {
  col1: "#AD1FEA",
  col2: "#4661E6",
  col3: "#373F68",
  col4: "#F2F4FF",
  col6: "#3A4374",
  col7: "#647196",
  col8: "#F49F85",
  col9: "#62BCFA",
  col5: "#F7F8FD",
  white: "#FFFFFF",
  col11: "#F2F4FE",
  col12: "#1A4374",
};

export const lightTheme = {
  background: colors.col4,
  text: colors.col6,
  elements: colors.white,
  lightText: colors.col5,
  categoryType: colors.col11,
};

export const darkTheme = {
  text: colors.col4,
  background: colors.col3,
  elements: colors.col6,
  lightText: colors.col9,
  categoryType: colors.col7,
};
